import { render, staticRenderFns } from "./Beautiful.vue?vue&type=template&id=7126aee6&scoped=true"
import script from "./Beautiful.vue?vue&type=script&lang=js"
export * from "./Beautiful.vue?vue&type=script&lang=js"
import style0 from "./Beautiful.vue?vue&type=style&index=0&id=7126aee6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7126aee6",
  null
  
)

export default component.exports